<template>
  <div class="quiz-container">
    <div class="quiz-header">
       <figure class="image awsLogo rounded quiz-logo">
          <img class="is-rounded imageWidth" :src="logo" />
        </figure>
      <total-timer />
      <div class="header quiz-title is-size-3 has-text-weight-bold" :style="quizMessage" >{{quizName}}</div>
    </div>
    <div class="quiz-questions">
      <div class="box" :style="boxSettings" >
        <div
        :style="quizLoginSettings"
          class="question-text mb-2" 
          v-html="compiledMarkdown(question.question)"
        ></div>
        <question-timer :qduration="question"/>
        <div class="wrap mt-2">
          <div class="options-wrap">
            <div
            :style="quizOptions"
             class="question-options my-2 py-2 is-size-5"
              v-for="(option, index) in question.options"
              @click="selectedOption(index)"
              :class="{'is-selected': optionSelected === index}"
              :key="index"
              v-html="compiledMarkdown(option)"
            > 
            </div>
          </div>
        </div>
       
        <div class="question-controls mt-4">
           <div class="question-no is-size-5 mt-1" :style="quizLoginSettings">
          Question No 
          <p class="is-size-6" :style="quizLoginSettings" >
            {{questionIndex + 1}}
            ( {{questionIndex + 1}} of {{totalQuestions}} )
          </p>
        </div>
          <button
          :disabled="!allowNextQue"
            class="button" :style="buttonSettings"

            @click="next()"
          >{{ (questionIndex + 1 >= totalQuestions)?'Finish':'Next' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import marked from 'marked';
import totalTimer from '../common/totaltimer.vue';
import questionTimer from '../common/questiontimer.vue';

export default {
  name: 'Quiz',
  components: {
    totalTimer,
    questionTimer,
  },
  data() {
    return {
      optionSelected: '',
      allowNextQue: false,
      
    };
  },
  methods: {
    selectedOption(index) {
      this.optionSelected = index;
      this.allowNextQue = true;
      
    },
    next() {
      this.optionSelected = this.optionSelected !== '' ? this.optionSelected + 1 : this.optionSelected;
      this.$store.dispatch('nextQuestion', { id: this.question.questionId, selected: this.optionSelected });
      this.optionSelected = '';
      this.allowNextQue = false;
    },
    compiledMarkdown(text) {
      return marked(text, { sanitize: true });
    },

  },
  computed: {
    ...mapGetters([
      'question',
      'questionIndex',
      'totalQuestions',
      'formattedElapsedTime',
      'quizName',
      'logo',
       'backgroundColor', 'primaryColor', 'textColor'
    ]),
    hrMargin(){
      return{
         "background-color": this.primaryColor
      }
    },
    boxSettings(){
      return{
        "background-color": this.backgroundColor,
      }
    },
    buttonSettings(){
      return{
        "background-color": this.primaryColor,
        "border-color": this.primaryColor,
        "color": this.textColor
      }
    },
    quizLoginSettings(){
      return{
        "color": this.textColor
        
      }
    },
    quizMessage(){
      return{
        "color": this.primaryColor
        
      }
    },
    quizOptions(){
      return{
        "color": this.textColor,
        "border-color": this.primaryColor 
      }
    }


  },
};
</script>

<style lang="scss" scoped>
.quiz-container {
  width: 100vw;
  height: 100vh;
  background-color: $app-background-color;

.awsLogo{
    width: 125px;
    align-items: initial;
    margin-top: 32px;

    .imageWidth{
          width: 125px;
          height: 100px;
        }
  }
  .quiz-header {
    display: flex;
    justify-content: start;
    margin-left: 150px;

    .header {
      //font-size: 32px;
      line-height: 40px;
      color: $primary-color;
      padding: 4rem;
      margin-left: 65px;
    }
    .timmer {
      position: absolute;
      top: 5%;
      right: 4%;
      font-size: 48px;
      color: $primary-color;
      padding: 3rem;
    }
  }

  .quiz-questions {
    display: flex;
    justify-content: center;

    .box {
      background-color: $box-background-color;
      border-radius: 1.56rem;
      padding: 30px;
      //min-height: calc(100vh - 35vh);
      //max-height: calc(100vh - 35vh);
      display: flex;
      flex-direction: column;
      flex: 0 0 85%;
      align-items: unset;

      .question-no {
        font-size: 15px;
        color: $primary-color;
        padding: 0.13rem;

        p {
          font-weight: bold;
          display: inline;
        }
      }
      .question-text {
        display: flex;
        font-weight: bold;
        color: $brand-color;
        text-align: justify;
        text-justify: inter-word;
        padding: 0.13rem;
        max-height: 35%;
        font-size: 1.7rem;
        
      }

      .wrap {
        display: flex;
        flex: 1 0 35%;
        .options-wrap {
          display: flex;
          flex: 0 0 100%;
          // flex-wrap: wrap;
          flex-direction: column;
          justify-content: space-between;

          .question-options {
            padding: 1rem 1rem;
            color: $brand-color;
            display: flex;
            flex-grow: 0;
            flex-wrap: wrap;
            border: 1px solid $primary-color;
            border-radius: 8px;
            justify-content: left;
            align-content: center;
            cursor: pointer;
            //font-size: 20px !important;

            p {
              display: inline;
            }
          }

          .is-selected {
            background-color: fade-out(lavender,0.75);
            color: $white;
          }
        }
      }
      .question-controls {
        display: flex;
        justify-content: space-between;
        &:focus {
          border: 1px solid $primary-color;
        }
        .button {
          border-radius: 20px;
          font-weight: 600;
          font-size: 16px;
          text-transform: uppercase;
          &:hover {
            color: $white;
          }
        }
      }
    }
  }
}
</style>
